import styled from 'styled-components';

const UserBoxName = styled.div`
  font-size: 17px;
  margin-bottom: 5px;
  margin-right: 5px;
`;

export default UserBoxName;
